import React, { useState, useEffect } from 'react';
import apiClient from '../../api/apiClient';
import { useAuth } from '../../context/AuthContext';

export default function ManagerFilter({ value, onChange, style }) {
  const { user } = useAuth();
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    if (!user || !['admin', 'super_admin'].includes(user.role)) return;
    apiClient.get('/users/managers')
      .then(res => setManagers(res.data.managers || []))
      .catch(() => setManagers([]));
  }, [user]);

  // Only show for admins
  if (!user || !['admin', 'super_admin'].includes(user.role)) return null;
  if (managers.length === 0) return null;

  return (
    <select
      value={value || ''}
      onChange={e => onChange(e.target.value || null)}
      style={{
        padding: '0.4rem 0.625rem',
        border: '1.5px solid #e2e8f0',
        borderRadius: '0.5rem',
        fontSize: '0.8rem',
        outline: 'none',
        color: '#1e293b',
        background: value ? '#ede9fe' : '#f8fafc',
        ...style,
      }}
    >
      <option value="">All Managers</option>
      {managers.map(m => (
        <option key={m.id} value={m.id}>{m.name || m.email}</option>
      ))}
    </select>
  );
}
